import {
    DirectoryPillBar,
    type DirectoryPillBarBreadcrumb,
} from '~/ui-rocco/pages/directory-browse/DirectoryPillBar';
import type { FilterSortOption } from '@rocco/ui/filter-sort/components/Filters';
import type { useSearchFilters } from '@rocco/ui/filter-sort/hooks/use-search-filters';

interface ProductsFilterBarProps {
    /** Breadcrumbs for extracting parent category info */
    breadcrumbs: DirectoryPillBarBreadcrumb[];
    /** Search filters from useCategoryFilterSort hook */
    searchFilters: ReturnType<typeof useSearchFilters>;
    /** Sort options from useCategoryFilterSort hook */
    sortOptions: FilterSortOption[];
    /** Whether currently on suppliers endpoint */
    isSuppliersEndpoint: boolean;
    /** Handler for toggling between Products/Brands */
    onToggle: () => void;
    /** Local state for the toggle animation */
    localIsSuppliers: boolean;
    /** Whether to disable highlight transition */
    disableHighlightTransition: boolean;
    /** Setter for localIsSuppliers */
    setLocalIsSuppliers: (value: boolean) => void;
    /** Setter for disableHighlightTransition */
    setDisableHighlightTransition: (value: boolean) => void;
    /** Category pills to show in suppliers mode (replaces filter pills) */
    supplierCategories?: { id: number; title: string; link: string }[];
}

/**
 * Products filter bar (desktop). Thin adapter over the shared DirectoryPillBar,
 * supplying the Products/Brands toggle. The generic bar is shared with the
 * professionals and projects directory browse pages.
 */
export const ProductsFilterBar = ({
    breadcrumbs,
    searchFilters,
    sortOptions,
    isSuppliersEndpoint,
    onToggle,
    localIsSuppliers,
    disableHighlightTransition,
    setLocalIsSuppliers,
    setDisableHighlightTransition,
    supplierCategories,
}: ProductsFilterBarProps) => {
    return (
        <DirectoryPillBar
            breadcrumbs={breadcrumbs}
            searchFilters={searchFilters}
            sortOptions={sortOptions}
            toggle={{
                leftLabel: 'Products',
                rightLabel: 'Brands',
                isRightActive: isSuppliersEndpoint,
                onToggle,
                localRightActive: localIsSuppliers,
                disableHighlightTransition,
                setLocalRightActive: setLocalIsSuppliers,
                setDisableHighlightTransition,
                rightCategories: supplierCategories,
            }}
        />
    );
};
